const PaymentElementHook = {
  mounted() {
    this.paymentMethodCache;

    const stripe = Stripe(window.STRIPE_PUBLIC_KEY);

    const appearance = {
      theme: 'stripe',
    };

    const options = {
      layout: 'tabs',
      defaultValues: {
        billingDetails: {
          name: this.customerName(),
          phone: this.customerPhoneNumber(),
          email: this.customerEmail(),
        },
      },
    };

    const elements = stripe.elements({
      clientSecret: this.clientSecret(),
      appearance,
    });

    const paymentElement = elements.create('payment', options);
    paymentElement.mount(this.el);
    paymentElement.on('change', (e) => {
      this.paymentMethodCache = e.value.type;

      this.pushEventTo(this.el, 'update-payment-element', {
        complete: e.complete,
        payment_method: e.value.type,
      });
    });

    this.el.addEventListener('confirm', async () => {
      const result = await stripe.confirmSetup({
        elements,
        confirmParams: {
          return_url: this.returnUrl(),
        },
        redirect: 'if_required',
      });

      if (result.setupIntent) {
        this.pushEventTo(this.el, 'confirmation', {
          payment_method: result.setupIntent.payment_method,
        });
      } else {
        this.pushEventTo(this.el, 'confirmation', { error: result.error.message });
      }
    });
  },

  returnUrl() {
    return this.el.dataset.returnUrl;
  },

  customerName() {
    return this.el.dataset.custmerName;
  },

  customerPhoneNumber() {
    return this.el.dataset.customerPhoneNumber;
  },

  customerEmail() {
    return this.el.dataset.customerEmail;
  },

  clientSecret() {
    return this.el.dataset.clientSecret;
  },
};

export default PaymentElementHook;
